const COLLAB_PATH = 'ccollab'; // the extra c is for Confluence

export const getCollabProviderUrl = () => {
	return `${window.location.origin}/${COLLAB_PATH}`;
};
